import Vue from "vue";

import { PRODUCTION_MODE } from "./globals";
Vue.config.productionTip = PRODUCTION_MODE;

import VueRouter from "vue-router";
Vue.use(VueRouter);

import Vuex from "vuex";
Vue.use(Vuex);

//< Element UI
import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

// tslint:disable-next-line:no-import-side-effect
import "./css/element-variables.scss";

Vue.use(Element, { locale });
//Element UI >

// tslint:disable-next-line:no-import-side-effect
import "@/frontend/css/main.styl";

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
